<template>
  <transition name="fade">
    <div v-if="visible" class="session-warning">
      <div class="session-warning__info">
        <v-icon class="session-warning__icon">warning</v-icon>
        <p v-html="$t(`${namespace}.text`)" class="session-warning__text" />
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { SESSION_EXPIRES_TIME } from 'utils/constants'

export default {
  name: 'SessionExpiresWarning',
  computed: {
    ...mapState({
      sessionExpiresTime: state => state.sessionExpiresTime.date
    }),

    sessionExpired () {
      return Boolean(this.$route.query && this.$route.query.sessionExpired)
    }
  },
  data () {
    return {
      namespace: 'Components.SessionExpiresWarning',
      visible: false
    }
  },
  methods: {
    ...mapActions({
      setSessionExpiresTime: 'sessionExpiresTime/set'
    }),

    clearUrlQueryParam () {
      window.setTimeout(() => {
        this.$router.push(this.$route.path).catch(() => {})
      }, 100)
    },

    toggleVisible () {
      const nowMilliseconds = new Date().getTime()
      const expiresDateMilliseconds = this.sessionExpiresTime
        ? new Date(this.sessionExpiresTime).getTime()
        : null

      if (
        this.sessionExpired ||
        (expiresDateMilliseconds && nowMilliseconds >= expiresDateMilliseconds)
      ) {
        this.visible = true
        localStorage.removeItem(SESSION_EXPIRES_TIME)
        this.setSessionExpiresTime(null)
        this.clearUrlQueryParam()
        window.setTimeout(() => { this.visible = false }, 10000)
        return
      }

      this.visible = false
    }
  },
  mounted () {
    this.toggleVisible()
  }
}
</script>

<style lang="scss" scoped>
.session-warning {
  background-color: #fffadd;
  border-bottom: 1px solid $gray-4;
  left: 0;
  padding: 0 16px;
  position: fixed;
  right: 0;
  text-align: center;
  top: 0;
  z-index: 1000;
}

.session-warning__info {
  align-items: center;
  display: flex;
  min-height: 60px;
  justify-content: center;
  justify-items: center;
}

.session-warning__icon {
  color: $warning-2 !important;
  margin-right: 8px;
}

.session-warning__text {
  margin: 0;

  span {
    color: $gray-8;
    font-weight: 600;
  }
}
</style>
